import * as React from 'react';

export interface IUniqueCaseIdControlProps {
    onChange: (value: string) => void;
    readonly?: boolean;
    value: string | undefined;
}

export function UniqueCaseIdControl(props: IUniqueCaseIdControlProps) {
    const [localValue, setLocalValue] = React.useState<string>(props.value ?? '');

    return (
        <input
            className="form-control"
            type="text"
            maxLength={100}
            name="uniqueCaseId"
            value={localValue}
            onChange={(e) => setLocalValue(e.target.value)}
            onBlur={() => props.onChange(localValue)}
            disabled={props.readonly}
        />
    );
}
